module.exports = __webpack_public_path__ + "static/media/danger-circle.b16de107.svg";